import config from "../config";
import commonService from "./commonService";
import CONSTANTS from "src/data/constants";

const masterListService = {
  getVesselList,
  getVesselDepartmentList,
  getEquipmentList,
  getEmployeeList,
  getModelList,
  getGstList,
  getPortList,
  getIMPACodes,
  getIMPACategoryList,
  getOrderTypeList,
  getUOMCodes,
  getMainCodes,
  getVendorList,
  getContactPersonList,
  getSparePartList,
  getCurrencyList,
  submitMLQ,
  getAIIPMSContractCategories,
  getRewardMasterList,
 
  // DeliveryOrderVendorList
};

function getVendorList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("vendorList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService.restCall({
        url: `${config.apiUrl}${config.snapshot.getAllMasters}`,
        method: 'POST',
        headers: [
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
        ],
        data: {}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "vendorId",
            label: "vendorName",
            associatedId: "vendorId",
            code: "vendorCode",
            currencyId: "currencyId",
            noOfDays: "noOfDays",
            isActive:"isActive",
            gstId:"defaultGstId"
          });
          localStorage.setItem("vendorList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getVesselList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("vesselList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "vesselSuffix",
            label: "bargeName",
            associatedId: "bargeId",
            isActive:"isActive"
          });
          localStorage.setItem("vesselList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}
function submitMLQ(data, moduleId) {
  const merged = { ...{ moduleId: moduleId, transactionId: 5 }, ...data };
  var url = `${config.apiUrl}${config.snapshot.submitMLQ}`;
  return commonService.restCall({
    url,
    method: "POST",
    data: merged,
    headers: [{ moduleId: moduleId }, { transactionId: 5 }, { CategoryId: 0 }],
  });
}
function getVesselDepartmentList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("vesselDepartmentList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "vesselDepartmentId",
            label: "vesselDepartmentName",
            associatedId: "vesselDepartmentId",
            isActive: "isActive"
          });
          localStorage.setItem("vesselDepartmentList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getEmployeeList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("employeeList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "employeeId",
            label: "employeeName",
            associatedId: "employeeId",
            isActive: "isActive"
          });
          localStorage.setItem("employeeList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getEquipmentList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("equipmentList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "equipmentId",
            categoryName: "categoryName",
            label: "equipmentName",
            associatedId: "equipmentId",
            isActive: "isActive"
          });
          for(let i in data){
            data[i].label = data[i].categoryName ? data[i].categoryName +" - "+ data[i].label : data[i].label;
           }
          localStorage.setItem("equipmentList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getOrderTypeList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("orderType");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "orderTypeId",
            label: "orderTypeName",
            associatedId: "orderTypeId",
            orderCategory: "orderCategory",
            isActive: "isActive"
          });
          localStorage.setItem("orderType", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getIMPACodes(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("impaCodes");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "iMPACode",
            associatedId: "iMPACodeId",
            iMPACode: "iMPACode",
            label: "iMPACategoryDescription",
            iMPADescription: "iMPACategoryDescription",
            remarks: "remarks",
            uomId: "uomId",
            mainCode: "mainCode",
            mainCodeDescription: "mainCodeDescription",
            mainCodeId: "mainCodeId",
            isActive: "isActive"
          });
          for(let i in data){
            data[i].label = data[i].iMPACode ? data[i].iMPACode +" - "+ data[i].label : "";
           }
          localStorage.setItem("impaCodes", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getIMPACategoryList() {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("impaCategory");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url: `${config.apiUrl}${config.snapshot.impaCategoryList}`,
          method: "GET",
          headers: [
            { moduleId: 1 },
            { transactionId: 9 },
            { CategoryId: "0" },
          ],
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "contractCategoryCode",
            associatedId: "iMPACodeId",
            iMPACategory: "contractCategoryCode",
            label: "contractCategoryName",
            remarks: "remarks",
            mainCodeId: "mainCodeId",
          });
          localStorage.setItem("impaCategory", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getPortList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("portList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
            url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
            method:'POST',
            headers:[
            { moduleId: 1 },
            { transactionId },
            { CategoryId: 1 },
        ],
        data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "portId",
            label: "portName",
            associatedId: "portId",
            isActive:"isActive"
          });
          localStorage.setItem("portList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getUOMCodes(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("uomCodes");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "uomCode",
            uomCode: "uomCode",
            associatedId: "uomId",
            label: "uomCode",
            isActive: "isActive"
          });
          localStorage.setItem("uomCodes", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getMainCodes(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("mainCode");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = response.data;
          data = commonService.constructListOptions(response.data, {
            value: "mainCode",
            label: "mainCodeDescription",
            mainCode: "mainCode",
            associatedId: "mainCodeId",
            isActive: "isActive"
          });
          localStorage.setItem("mainCode", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getRewardMasterList(transactionId) {

  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("rewardCode");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService.restCall({
          url: `${config.apiUrl}${config.snapshot.getAllActiveMasters}`,
          method: "POST",
          headers: [
            { moduleId: 1 },
            { transactionId },
            { CategoryId: "0" },
          ],
          data: {
            "keyId":0,
          }
        }).then((response) => {
          data = response.data;
          data = commonService.constructListOptions(response.data, {
            value: "rewardCode",
            label: "rewardDescription",
            rewardCode: "rewardCode",
            associatedId: "rewardId",
            rewardDescription: "rewardDescription",
            isActive:"isActive"
          });
          
          for(let i in data){
            data[i].label = data[i].rewardCode ? data[i].rewardCode +" - "+ commonService.addElipsis( data[i].rewardDescription,40) : "";
           }
          localStorage.setItem("rewardCode", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getModelList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("modelList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "sparesModelId",
            sparesEquipmentId: "sparesEquipmentId",
            label: "modelType",
            associatedId: "sparesModelId",
            isActive: "isActive",
            make:"make",
            serialNo:"serialNo"
          });
          localStorage.setItem("modelList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getContactPersonList(transactionId,linkId) {
  return new Promise((resolve, reject) => {
    let data = [];
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{
        linkId
      }
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "addressId",
            email: "email",
            label: "contact",
            associatedId: "addressId",
            linkId: "linkId",
            isActive: "isActive"
          });
          localStorage.setItem("contactPerson", JSON.stringify(data));
          resolve(data);
        });
  });
}

function getSparePartList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("sparePartList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "partNo",
            sparePartId: "sparePartId",
            label: "partName",
            partDescription: "partName",
            associatedId: "sparePartId",
            partNo: "partNo",
            uomId: "uomid",
            modelId: "modelId",
            isActive: "isActive",
          });
          for(let i in data){
            data[i].label = data[i].partNo ? data[i].partNo +" - "+ data[i].label : "";
           }
          localStorage.setItem("sparePartList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getCurrencyList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("currencyList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
          url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "currencyId",
            label: "currencyCode",
            associatedId: "currencyId",
            isActive: "isActive"
          });
          localStorage.setItem("currencyList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}
function getGstList(transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("gstList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService.restCall({
        url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        }).then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "gstId",
            label: "gstName",
            associatedId: "gstId",
            orderId: 'gstCode',
            gstPercentage:"gSTPercentage",
            isActive:"isActive"
          });
          localStorage.setItem("gstList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
}

function getAIIPMSContractCategories  (transactionId) {
  return new Promise((resolve, reject) => {
    let data = [],
      list = localStorage.getItem("contractCategoryList");
    if (list) {
      data = JSON.parse(list);
      resolve(data);
    } else {
      commonService
        .restCall({
           url:`${config.apiUrl}${config.snapshot.getAllMasters}`,
          method:'POST',
          headers:[
          { moduleId: 1 },
          { transactionId },
          { CategoryId: 1 },
      ],
      data:{}
        })
        .then((response) => {
          data = commonService.constructListOptions(response.data, {
            value: "contractCategoryId",
            label: "contractCategoryName",
            associatedId: "contractCategoryId",
            name : "contractCategoryId",
            mainCodeId : "mainCodeId",
            isActive: "isActive"
          });
          localStorage.setItem("contractCategoryList", JSON.stringify(data));
          resolve(data);
        });
    }
  });
};

//In Delivery Order No of days is Not Added for get all master Calls
// function DeliveryOrderVendorList() {
//   return new Promise((resolve, reject) => {
//     let data = []
//       commonService
//         .restCall({
//           url: `${config.apiUrl}${config.snapshot.vendorList}`,
//           method: "GET",
//           headers: [
//             { moduleId: 31 },
//             { transactionId: 0 },
//             { CategoryId: "0" },
//           ],
//         })
//         .then((response) => {
//           data = commonService.constructListOptions(response.data, {
//             value: "vendorId",
//             label: "vendorName",
//             associatedId: "vendorId",
//             code: "vendorCode",
//             currencyId: "currencyId",
//             noOfDays: "noOfDays",
//           });
//           resolve(data);
//         });
//   });
// }

export default masterListService;
